import { BrowserRouter, Routes, Route } from "react-router-dom";
import Authlogin from "./pages/auth/login.js";
import Dashboard from "./pages/dash/dashboard.js";
import ChangeMyPassword from "./pages/profile/changemypassword.js";
import ManageUser from "./pages/user/manageuser.js";
import Categories from "./pages/master/categories.js"
import VendorRegistration from "./pages/vendor/vendor-registration.js"
import Subcategories from "./pages/master/subcategories";
import Brands from './pages/master/brands.js'
import VendorManagement from './pages/vendor/vendor-management.js'
import VendorEdit from './pages/vendor/vendor-update.js'
import ProductType from './pages/master/producttype.js';

// Import product management components
import ProductManagement from './pages/master/products/product-management.js'
import ProductRegistration from './pages/master/products/product-registration.js'
import ProductUpdate from './pages/master/products/product-update.js'
import ProductExcelUpload from './pages/master/products/product-excel-upload.js'

import PurchaseOrderCreate from './pages/purchaseOrder/purchase-order-create.js'
import PurchaseOrderUpdate from './pages/purchaseOrder/purchase-order-update.js'
import PurchaseOrderList from './pages/purchaseOrder/purchaseorderlist.js'
import PurchaseOrderView from './pages/purchaseOrder/purchase-order-view.js';
import PurchaseOrderForApproval from './pages/purchaseOrder/purchaseorderforapproval.js';
import PurchaseOrderPrint from './pages/purchaseOrder/purchase-order-print.js';

import Stocks from './pages/stock/stock-managment.js';
import StockItems from './pages/stock/stockItem-management.js';
import StocksAdjustment from './pages/stock/stock-adjustment.js';

import GrnCreate from './pages/grn/grn-create.js';
import GrnUpdate from './pages/grn/grn-update.js';
import GrnList from './pages/grn/grn-list.js';
import GrnView from './pages/grn/grn-view.js';
import GrnForApproval from './pages/grn/grn-list-forapproval.js';
import GrnPrint from './pages/grn/grn-print.js';

import UserList from './pages/mlm/userlist.js';
import UserView from './pages/mlm/user-view.js';
import MLMUserEdit from "./pages/mlm/mlm-user-edit.js"; // Import the new edit component
import Uom from "./pages/master/uom.js";
import Sector from "./pages/master/sector.js";
import Segment from "./pages/master/segment.js";

import FinancialSettings from "./pages/system/financial.js";
import GeneralSettings from "./pages/system/general.js";
import MonthendProcess from "./pages/system/monthend.js";
import StocksTransfer from "./pages/stock/stock-transfer.js";
import StocksTransferForm from "./pages/stock/transfer-from.js";
import { StockTransferView } from "./pages/stock/stock-transfer-view.js";
import StockTransferPrint from "./pages/stock/stock-transfer-print.js";
import StockReport from "./pages/reports/stock/stock-report.js";
import Reports from "./pages/reports/reports.js";
import ProductAttribute from "./pages/master/products/product-attribute.js";
import Orders from "./pages/orders/orders.js";
import OrderView from "./pages/orders/order-view.js";
import PendingOrderProcesss from "./pages/orders/pending-order-processs/pending-process.js";
import Transactions from "./pages/orders/transactions/order-transactions.js";
import NeedToProcess from "./pages/warehouse/need-to-process.js";
import MarkAsReady from "./pages/warehouse/mark-as-Ready.js";
import InProcessing from "./pages/warehouse/in-processing.js";
import ReadyToShipped from "./pages/warehouse/ready-to-shipped.js";
import TellerPaymentsPending from "./pages/teller/pending-payments.js";
import TellerNeedToIssue from "./pages/teller/need-to-issue.js";
import PendingCancels from "./pages/orders/pending-cancels.js";
import TellerSummery from "./pages/reports/teller/teller-summery.js";
import MLMUserReport from "./pages/reports/mlm/mlm-user-report.js";
import UserRequests from "./pages/mlm/user-requests.js";
import WalletRequests from "./pages/mlm/wallet-requests.js";
import StockAnalysisReport from "./pages/reports/stock-analysis/stock-analysis-report.js";
import DailySaleReport from "./pages/reports/sale/daily-sale-report.js";
import DailySaleReportChart from "./pages/reports/sale/daily-sale-report-chart.js";
import MLMUserMonthlyReport from "./pages/reports/mlm/mlm-user-monthly-performance.js";
import MLMUserMonthlyReportByConsultant from "./pages/reports/mlm/mlm-user-monthly-performance-by-consultant.js";
import StockItemMovementReport from "./pages/reports/stock/stock-item-movement-report/stock-item-movement-report.js";
import ProductOffer from "./pages/stock/product-offers.js";
import MonthEndSaleSummary from "./pages/reports/sale/month-end-sale-summary.js";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Authlogin />} />
        <Route path="/login" element={<Authlogin />} />
        <Route path="/dash" element={<Dashboard />} />
        <Route path="/updatepassword" element={<ChangeMyPassword />} />
        <Route path="/usermanagement" element={<ManageUser />} />

        <Route path="/pocreate" element={<PurchaseOrderCreate />} />
        <Route path="/poedit/:id" element={<PurchaseOrderUpdate />} />
        <Route path="/polist" element={<PurchaseOrderList />} />
        <Route path="/poview/:id" element={<PurchaseOrderView />} />
        <Route path="/popendinglist" element={<PurchaseOrderForApproval />} />
        <Route path="/poprint/:id" element={<PurchaseOrderPrint />} />

        {/* MasterData */}
        <Route path="/master/categories" element={<Categories />} />
        <Route path="/master/subcategories/:categoryId" element={<Subcategories />} />

        <Route path="/master/brands" element={<Brands />} />
        <Route path="/master/producttype" element={<ProductType />} />

        <Route path="/master/vendorlist" element={<VendorManagement />} />
        <Route path="/master/vendorcreate" element={<VendorRegistration />} />
        <Route path="/master/vendorupdate/:id" element={<VendorEdit />} />

        <Route path="/master/productlist" element={<ProductManagement />} />
        <Route path="/master/productlist/attributes/:id" element={<ProductAttribute />} />
        <Route path="/master/productcreate" element={<ProductRegistration />} />
        <Route path="/master/productupdate/:id" element={<ProductUpdate />} />
        <Route path="/master/productexcelupload" element={<ProductExcelUpload />} />
        <Route path="/master/uom" element={<Uom />} />
        <Route path="/master/sectors" element={<Sector />} />
        <Route path="/master/segments" element={<Segment />} />

        {/* Stock */}
        <Route path="/stocks/management" element={<Stocks />} />
        <Route path="/stocks/adjustment" element={<StocksAdjustment />} />
        <Route path="/stocks/transfer" element={<StocksTransfer />} />
        <Route path="/stocks/transfer/:transferId" element={<StocksTransferForm />} />
        <Route path="/stocks/transfer/view/:transferId" element={<StockTransferView />} />
        <Route path="/stocks/transfer/print/:transferId" element={<StockTransferPrint />} />
        <Route path="/stocks/itemsmanagment/:stockid" element={<StockItems />} />
        <Route path="/stocks/product-offers" element={<ProductOffer />} />

        {/* GRN */}
        <Route path="/grnlist" element={<GrnList />} />
        <Route path="/grncreate" element={<GrnCreate />} />
        <Route path="/grnupdate/:id" element={<GrnUpdate />} />
        <Route path="/grnview/:id" element={<GrnView />} />
        <Route path="/grnpendinglist" element={<GrnForApproval />} />
        <Route path="/grnprint/:id" element={<GrnPrint />} />

        {/* Orders */}
        <Route path="/orders" element={<Orders />} />
        <Route path="/orders/view/:id" element={<OrderView />} />
        <Route path="/orders/pending-order-process" element={<PendingOrderProcesss />} />"
        <Route path="/orders/transactions" element={<Transactions />} />
        <Route path="/orders/pending-cancels" element={<PendingCancels />} />

        {/* Wharehouse */}
        <Route path="/warehouse/need-to-process" element={<NeedToProcess />} />
        <Route path="/warehouse/mark-as-ready" element={<MarkAsReady />} />
        <Route path="/warehouse/in-processing" element={<InProcessing />} />
        <Route path="/warehouse/ready-to-shipped" element={<ReadyToShipped />} />

        {/* Teller */}
        <Route path="/teller/payments-pending" element={<TellerPaymentsPending />} />
        <Route path="/teller/need-to-issue" element={<TellerNeedToIssue />} />


        {/* MLM */}
        <Route path="/mlm/userlist" element={<UserList />} />
        <Route path="/mlm/userview/:id" element={<UserView />} />
        <Route path="/mlm/userlist/edit/:id" element={<MLMUserEdit />} /> {/* Updated to use MLMUserEdit */}
        <Route path="/mlm/user-requests" element={<UserRequests />} />
        <Route path="/mlm/wallet-requests" element={<WalletRequests />} />


        {/* System Config */}
        <Route path="/config/financial" element={<FinancialSettings />} />
        <Route path="/config/general" element={<GeneralSettings />} />
        <Route path="/config/monthend" element={<MonthendProcess />} />

        {/* Reports */}
        <Route path="/reports" element={<Reports />} />
        <Route path="/reports/stock/stock-liveupdate-report" element={<StockReport />} />
        <Route path="/reports/stock/stock-item-movement-report" element={<StockItemMovementReport />} />
        <Route path="/reports/teller/teller-transaction-summery" element={<TellerSummery />} />
        <Route path="/reports/mlm/mlm-user-report" element={<MLMUserReport />} />
        <Route path="/reports/stock/stock-analysis-report" element={<StockAnalysisReport />} />
        <Route path="/reports/mlm/montly-performance-report" element={<MLMUserMonthlyReport />} />
        <Route path="/reports/sale/daily-sale-report" element={<DailySaleReport />} />
        <Route path="/reports/sale/daily-sale-report-chart" element={<DailySaleReportChart />} />
        <Route path="/report/mlm/monthly-performance-report-by-consultant" element={<MLMUserMonthlyReportByConsultant />} />
        <Route path="/reports/sale/month-end-sale-summary" element={<MonthEndSaleSummary />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;